import React from "react";
import { useNavigate } from "react-router-dom"; import UsersList from "../../Modals/usersList";
import { Box, Tabs, Tab } from "@mui/material";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
;
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ViewPromotion = () => {
  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const usersList = [
    { id: "1", label: "John Doe", avatar: "/static/images/user_placeholder.png" },
    { id: "2", label: "Jane Smith", avatar: "/static/images/user_placeholder.png" },
    { id: "3", label: "Michael Scott", avatar: "/static/images/user_placeholder.png" },
    { id: "4", label: "Pam Beesly", avatar: "/static/images/user_placeholder.png" },
  ];
  const handleOpenAudience = () => {
    setSelectedUserIds(usersList.map((u) => u.id));
    setOpenUserModal(true);
  };
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Promotion Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-promotions")}>
            Promotion Management
          </button>{" "}
          - Promotion Detail
        </p>
      </div>


      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Promotion Detail" {...a11yProps(0)} />
              <Tab label="Feedback & Rating" {...a11yProps(1)} />

            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          {/* promotion Info */}


          <div className="section_title">
            <h2>Promotion Info</h2>
          </div>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Image</h6>
              <figure>
                <img src="/static/images/placeholder.png" alt="img" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Title</h6>
              <p>Exclusive Store Deal</p>
            </div>
            <div className="w_33">
              <h6>Type</h6>
              <p>App only</p>
            </div>
            <div className="w_33">
              <h6>Date Registered</h6>
              <p>01 March 2025</p>
            </div>
            <div className="w_33">
              <h6>Schedule</h6>
              <p>2025-06-01 to 2025-06-30</p>
            </div>
            <div className="w_33">
              <h6>Target Audience</h6>
              <p><button className="anchor_link" onClick={handleOpenAudience}>All Users</button></p>
            </div>
            <div className="w_33">
              <h6>URL (for external articles)</h6>
              <p>Lorem ipsum dolor sit amet.</p>
            </div>
            <div className="w_100">
              <h6>Description</h6>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. At, eos ea porro eum omnis ex?</p>
            </div>
          </div>

        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <PromotionFeedbackTable showPromotionColumn={false} />
        </CustomTabPanel>
      </div>
      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default ViewPromotion;
